import React from "react";
import qapi from "views_shared/app/javascript/api";
import EntityPicker from "../../entity_picker/EntityPicker";

function ProductPicker({ onProductPicked, onKeyDown, productsIdsToExclude, selectRef }) {
  return (
    <EntityPicker
      resource={qapi.products}
      select={["id", "name", "profile_image_url", "company_name"]}
      toOption={(product) => ({
        label: product.name,
        value: product.id,
        imageUrl: product.profile_image_url,
        subtitle: product.company_name,
      })}
      idsToExclude={productsIdsToExclude}
      onPicked={onProductPicked}
      onKeyDown={onKeyDown}
      selectRef={selectRef}
    />
  );
}

export default ProductPicker;
